import { RootState } from '@app/redux/root-reducer';

export const selectGetAllPromotion = (store: RootState) => store.promotionSlice.promotion;
export const selectAddPromotion = (store: RootState) => store.promotionSlice.addPromotion;
export const selectGetPromotionDetails = (store: RootState) =>
  store.promotionSlice.promotionDetails;
export const selectUpdatePromotionStatus = (store: RootState) =>
  store.promotionSlice.updatePromotionStatus;
